<script setup lang="ts">
import { Toaster } from '@/components/ui/sonner'
import 'vue-sonner/style.css'
</script>

<template>
  <RouterView />
  <Toaster position="top-right" rich-colors close-button />
</template>
